<footer id="app-mobile-footer">
    <a
        id="mobile-footer-home-link"
        [routerLink]="appRoutes.BASE"
        class="mobile-footer-item"
        aria-label="Go to Dashboard">
        <i class="fa-light fa-house"></i>
        <label for="mobile-footer-home-link" id="mobile-footer-home-link-label">Home</label>
    </a>
    <button
        pButton
        type="button"
        class="nav-btn mobile-footer-item"
        id="mobile-footer-menu-btn"
        (click)="isSidebarVisible.set(!isSidebarVisible())">
        <i class="fa-light fa-bars"></i>
        <label for="mobile-footer-menu-btn" id="mobile-footer-menu-btn-label">Menu</label>
    </button>
</footer>

<drawer
    [id]="'app-mobile-sidebar'"
    [showCloseIcon]="false"
    [styleClass]="'app-mobile-sidebar'"
    [(isVisible)]="isSidebarVisible">
    <div body id="sidebar-content" trapFocus>
        <app-navigation [isSidebarCollapsed]="false"></app-navigation>
    </div>
</drawer>
